import Vue from 'vue';
import Router from 'vue-router';
import store from '@/services/StoreService';

import AuthRoutes from '@/infrastructure/auth/routes';
import HomeRoutes from '@/infrastructure/home/routes';
import UserRoutes from '@/taskflex/users/routes';
import StudentRoutes from '@/taskflex/students/routes';
import CustomerRoutes from '@/taskflex/customers/routes';
import SkillRoutes from '@/taskflex/skills/routes';
import BlogRoutes from '@/taskflex/blog/routes';
import AdministrationRoutes from '@/taskflex/administration/routes';
import ConversationRoutes from '@/taskflex/conversations/routes';

Vue.use(Router);

const routes = [];

const routeFiles = [
    AuthRoutes,
    HomeRoutes,
    UserRoutes,
    StudentRoutes,
    CustomerRoutes,
    BlogRoutes,
    AdministrationRoutes,
    ConversationRoutes,
    SkillRoutes, // MUST BE LAST DUE TO CATCH-ALL
];

routeFiles.forEach((file) => {
    routes.push(...file.routes);
});

const router = new Router({
    mode: 'history',
    fallback: false,
    linkActiveClass: 'is-active',
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        }

        if (to.hash) {
            return { selector: to.hash };
        }

        return { x: 0, y: 0 };
    },
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!store.getters['auth/isLoggedIn']) {
            next({
                name: 'home',
                query: { redirect: to.fullPath },
            });
        }
    }

    if (to.matched.some(record => record.meta.requiresEmployee)) {
        // this route requires employee, check if logged in as employee
        // if not, redirect to login page.
        if (!store.getters['auth/isEmployee']) {
            next({
                name: 'home',
                query: { redirect: to.fullPath },
            });
        }
    }

    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/routes/index.js